var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4464 4.17857C10.4464 3.79394 10.1346 3.48214 9.75 3.48214C9.36537 3.48214 9.05357 3.79394 9.05357 4.17857V9.05357H6.26786C5.88323 9.05357 5.57143 9.36537 5.57143 9.75C5.57143 10.1346 5.88323 10.4464 6.26786 10.4464H9.75C10.1346 10.4464 10.4464 10.1346 10.4464 9.75V4.17857Z",
    fill: "#081754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 0C4.36522 0 0 4.36522 0 9.75C0 15.1348 4.36522 19.5 9.75 19.5C15.1348 19.5 19.5 15.1348 19.5 9.75C19.5 4.36522 15.1348 0 9.75 0ZM1.39286 9.75C1.39286 5.13448 5.13448 1.39286 9.75 1.39286C14.3655 1.39286 18.1071 5.13448 18.1071 9.75C18.1071 14.3655 14.3655 18.1071 9.75 18.1071C5.13448 18.1071 1.39286 14.3655 1.39286 9.75Z",
    fill: "#081754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.970a6389ffdec914e7efade794a7bcc5.svg";
export { ForwardRef as ReactComponent };